module.exports = __webpack_public_path__ + "media/audio2.9b5a4994.mp3";